import {
  getRequestUrl,
  isHttpOrHttps,
  isProxyUrlRelative,
  isValidProxyUrl,
  proxyUrlToAbsoluteURL
} from "./chunk-MHVPBPEZ.mjs";
import "./chunk-IC4FGZI3.mjs";
import "./chunk-NDCDZYN6.mjs";
export {
  getRequestUrl,
  isHttpOrHttps,
  isProxyUrlRelative,
  isValidProxyUrl,
  proxyUrlToAbsoluteURL
};
//# sourceMappingURL=proxy.mjs.map